module.exports = __webpack_public_path__ + "media/images/shared/delivery/pek-af885fee24905fb34e893297d3b9e6bb.jpg";